import styled from 'styled-components';

export const StyledReadingTime = styled.div<any>`
  .reading-time {
    color: var(--colors-grey-30);

    &__pre-text {
      font-weight: 700;
    }
  }
`;
